export default __webpack_public_path__ + "locales/el-GR/Common.json?hash=011e5ac28a1d9b0c1ab6919ac1d2bad3";